/* eslint-disable react-hooks/exhaustive-deps */
import "./styles.css";
import { useCallback, useContext, useEffect, useState } from "react";
import {
    Badge,
    Box,
    Button,
    Drawer,
    Grid,
    IconButton,
    Tooltip,
} from "@mui/material";
import NotificationsNoneIcon from "@mui/icons-material/NotificationsNone";
import DirectionsCarOutlinedIcon from "@mui/icons-material/DirectionsCarOutlined";
import PersonOutlineIcon from "@mui/icons-material/PersonOutline";
import HomeOutlinedIcon from "@mui/icons-material/HomeOutlined";
import HeaderUserBox from "./Userbox";
import AccountChangeModal from "./AccountSwitchModal";
// import useLazyQuery from "../../../shared/components/hooks/useLazyQuery";
import { getLocalStorageData } from "../../../shared/utils/localStorage";
import { SidebarContext } from "../../../contexts/SidebarContext";
import HeaderSearchBox from "./HeaderSearchBox";
import React from "react";
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';
import SwitchOrganization from "./OrgSwitchModal";
import { HashLoader } from "react-spinners";
import useMutation from "../../../shared/components/hooks/useMutation";
import useLazyQuery from "../../../shared/components/hooks/useLazyQuery";
import AlertsSidebar from "../../../pages/dashboard/dashboardV2/Alerts";
import { useLocation } from "react-router-dom";
import { AlertFilter } from "../../../pages/dashboard/dashboardV2/Alerts";

function Header() {
    const { account, setAccount, entity } = useContext(SidebarContext);
    const location = useLocation();
    const isLiveDashboard = /\/dashboard\/live-dashboard\/?$/.test(
        location.pathname
    );
    const [switchOrgModalOpen, setSwitchOrgModalOpen] = useState(false);
    const [alertsOpen, setAlertsOpen] = useState(false);
    const [alertsFilter, setAlertsFilter] = useState<AlertFilter>("normal");
    const [, setSessionVersion] = useState(0);
    const [unacknowledgedSos, setUnacknowledgedSos] = useState({
        person: false,
        vehicle: false,
    });
    useEffect(() => {
        const refreshSession = () => setSessionVersion((version) => version + 1);
        window.addEventListener("userDataUpdated", refreshSession);
        window.addEventListener("storage", refreshSession);
        return () => {
            window.removeEventListener("userDataUpdated", refreshSession);
            window.removeEventListener("storage", refreshSession);
        };
    }, []);

    const user = getLocalStorageData("userData");
    const isSuperAdminOrgLogin = JSON.parse(localStorage.getItem("superAdminOrgLogin") || "false");
    const hideNotificationsForSuperAdmin = user?.userType === "SuperAdmin";
    const [currentOrg, setCurrentOrg] = useState(user?.orgDetails || null); // keep current org display in modal
    const { modifyData } = useMutation();

    const handleAlertsClick = (filter: AlertFilter) => {
        setAlertsFilter(filter);
        setAlertsOpen(true);
    };

    const handleAlertsClose = () => {
        setAlertsOpen(false);
    };

    const handleUnacknowledgedSosChange = useCallback((state: {
        person: boolean;
        vehicle: boolean;
    }) => {
        setUnacknowledgedSos(state);
    }, []);



    // const {
    //   data: customerData,
    //   fetchData,
    //   loading,
    // } = useLazyQuery("/admin/customers/get-my-accounts", {
    //   params: {
    //     id: account?.selectedId ?? null,
    //     search: account?.searchTerm ?? "",
    //   },
    // });
    const localStorageData = getLocalStorageData("userData");
    useEffect(() => {
        if (account?.open !== null) {
            // fetchData();
            setAccount((prevData: any) => {
                return { ...prevData, accounts: { ...prevData?.accounts, list: [] } };
            });
        }
    }, [account?.selectedId, account?.searchTerm, account?.open]);

    const handleSwitchOrganisation = async (orgID: string | null, orgDetails: any) => {
        try {
            await modifyData(
                `/admin/organization/organization-switching`,
                "post", {
                orgID: orgID,
            });

            setCurrentOrg(orgDetails);
            // fetchData();
            const selectedOrganization = organizationData.find(
                (org: any) => org.id === orgID
            );
            const updatedLocalStorageData = {
                ...localStorageData,
                orgID: orgID,
                employee: {
                    ...localStorageData?.employee,
                    organization: {
                        ...selectedOrganization

                        //#OLDCODE
                        // ...localStorageData?.employee?.organization,
                        // name: orgDetails?.orgName,
                        // id: orgDetails?.orgID,
                    }
                }
            };
            localStorage.setItem("userData", JSON.stringify(updatedLocalStorageData));
            window.location.reload();
            <HashLoader />
        }

        catch (error) {
            console.error("Error switching organisation:", error);
        }
    };

    //Fetching organization data on component mount

    const { loading: organizationLoading, data, fetchData } = useLazyQuery(
        "/admin/config/organizationGroups",
    );

    useEffect(() => {
        // Check if the orgID in localStorage matches the orgID in the employee data
        // If they match, fetch the data
        if (localStorageData?.employee?.orgID === localStorageData?.employee?.organization?.id) {
            fetchData();
        }
    }, []);

    let organizationData = data;

    if (!organizationLoading) {
        if (localStorageData?.employee?.orgID !== localStorageData?.employee?.organization?.id) {
            organizationData = JSON.parse(localStorage.getItem('switchingOrgs') || '[]');
        }
    }
    const showSwitchOrgButton =
        organizationData?.length > 0 &&
        user?.employee?.role?.employeeType !== "Security Manager" &&
        !isSuperAdminOrgLogin;
    //#End of fetching organization data

    // useEffect(() => {
    //   if (customerData) {
    //     setAccount((prevData: any) => {
    //       let key = "All",
    //         dataSet: any = customerData?.items;
    //       if (localStorageData?.userType === "SuperAdmin") {
    //         key = customerData?.items?.[0]?.parent?.name;
    //       }
    //       if (key) {
    //         prevData.accounts[key] = {
    //           id: customerData?.items?.[0]?.parent?.accountId,
    //         };
    //       }
    //       return {
    //         ...prevData,
    //         selectedKey: key ?? prevData?.selectedKey,
    //         parent: prevData?.parent ?? key,
    //         accounts: {
    //           ...prevData?.accounts,
    //           list: dataSet,
    //         },
    //       };
    //     });
    //   }
    // }, [customerData]);

    return (
        <Box>
            <Grid container className={`headerContainer`}>
                <Grid item xs={4} className="dashboardText">
                    {isLiveDashboard ? "Live Dashboard" : entity?.entityTitle}
                </Grid>
                <Grid item xs={4} className="searchContainer">
                    <HeaderSearchBox />
                </Grid>
                <Grid item xs={4} className="userContainer">
                    {/* {organizationData?.length > 0 &&
                        user?.employee?.role?.employeeType !== "Security Manager" && */}
                    {showSwitchOrgButton &&
                        <Button
                            onClick={() => setSwitchOrgModalOpen(true)}
                            className="switchOrgButton"
                            endIcon={<ArrowDropDownIcon className="infoIcon" fontSize="small" />}
                            style={{ border: "1px solid #ccc", borderRadius: "4px", padding: "8px 16px" }}
                        >
                            {user?.employee?.organization?.name || "Choose Organization"}
                        </Button>
                    }
                    <SwitchOrganization
                        open={switchOrgModalOpen}
                        onClose={() => setSwitchOrgModalOpen(false)}
                        onConfirm={(orgID: string | null, orgDetails: any) => handleSwitchOrganisation(orgID, orgDetails)}
                        currentOrg={currentOrg}
                        title="Organization"
                        message="Please select an organization from the list."
                        organizationData={organizationData}
                        organizationLoading={organizationLoading}
                    />
                    {!hideNotificationsForSuperAdmin && <>
                    <Tooltip title="Notifications" arrow>
                        <IconButton
                            aria-label="Open notifications"
                            aria-haspopup="true"
                            aria-expanded={alertsOpen && alertsFilter === "normal"}
                            onClick={() => handleAlertsClick("normal")}
                            size="small"
                            sx={{ color: "#5a6b85" }}
                        >
                            <NotificationsNoneIcon />
                        </IconButton>
                    </Tooltip>
                    <Tooltip title="Driver / Employee SOS alerts" arrow>
                        <IconButton
                            aria-label="Open driver and employee SOS alerts"
                            aria-haspopup="true"
                            aria-expanded={alertsOpen && alertsFilter === "person-sos"}
                            onClick={() => handleAlertsClick("person-sos")}
                            size="small"
                            sx={{
                                color: unacknowledgedSos.person ? "#f44336" : "#5a6b85",
                                ...(unacknowledgedSos.person && {
                                    animation: "notificationVibrate 0.5s linear infinite",
                                    "@keyframes notificationVibrate": {
                                        "0%": { transform: "rotate(0deg)" },
                                        "20%": { transform: "rotate(-12deg)" },
                                        "40%": { transform: "rotate(12deg)" },
                                        "60%": { transform: "rotate(-12deg)" },
                                        "80%": { transform: "rotate(12deg)" },
                                        "100%": { transform: "rotate(0deg)" },
                                    },
                                }),
                            }}
                        >
                            <Badge color="error" variant={unacknowledgedSos.person ? "dot" : undefined}>
                                <PersonOutlineIcon />
                            </Badge>
                        </IconButton>
                    </Tooltip>
                    <Tooltip title="Cab / GPS SOS alerts" arrow>
                        <IconButton
                            aria-label="Open cab and GPS SOS alerts"
                            aria-haspopup="true"
                            aria-expanded={alertsOpen && alertsFilter === "vehicle-sos"}
                            onClick={() => handleAlertsClick("vehicle-sos")}
                            size="small"
                            sx={{
                                color: unacknowledgedSos.vehicle ? "#f44336" : "#5a6b85",
                                ...(unacknowledgedSos.vehicle && {
                                    animation: "notificationVibrate 0.5s linear infinite",
                                    "@keyframes notificationVibrate": {
                                        "0%": { transform: "rotate(0deg)" },
                                        "20%": { transform: "rotate(-12deg)" },
                                        "40%": { transform: "rotate(12deg)" },
                                        "60%": { transform: "rotate(-12deg)" },
                                        "80%": { transform: "rotate(12deg)" },
                                        "100%": { transform: "rotate(0deg)" },
                                    },
                                }),
                            }}
                        >
                            <Badge color="error" variant={unacknowledgedSos.vehicle ? "dot" : undefined}>
                                <DirectionsCarOutlinedIcon />
                            </Badge>
                        </IconButton>
                    </Tooltip>
                    <Tooltip title="Safe Home alerts" arrow>
                        <IconButton
                            aria-label="Open Safe Home alerts"
                            aria-haspopup="true"
                            aria-expanded={alertsOpen && alertsFilter === "safe-home"}
                            onClick={() => handleAlertsClick("safe-home")}
                            size="small"
                            sx={{ color: "#5a6b85" }}
                        >
                            <HomeOutlinedIcon />
                        </IconButton>
                    </Tooltip>
                    <Drawer
                        anchor="right"
                        open={alertsOpen}
                        onClose={handleAlertsClose}
                        ModalProps={{ keepMounted: true }}
                        PaperProps={{
                            sx: {
                                width: "min(420px, 100vw)",
                                height: "100vh",
                                overflow: "hidden",
                            },
                        }}
                    >
                        <AlertsSidebar
                            onClose={handleAlertsClose}
                            onUnacknowledgedSosChange={handleUnacknowledgedSosChange}
                            filter={alertsFilter}
                        />
                    </Drawer>
                    </>}
                    {/* {account && (
            <Button
              className="googleAdsAccount"
              color="secondary"
              onClick={() => {
                // setOpen(true);
                setAccount((prevData: any) => {
                  return { ...prevData, open: "all" };
                });
                // if (account?.accounts?.list?.length === 0) fetchData();
              }}
            >
              <GCTooltip
                title={
                  <React.Fragment>
                    <Typography variant="body2" color="inherit">
                      Account Id
                    </Typography>
                    {account?.id
                      ? account?.id
                          ?.toString()
                          ?.replace(/(\d{3})(\d{3})(\d{4})/, "$1-$2-$3")
                      : localStorageData?.userType === "SuperAdmin"
                      ? (account as any)?.data?.[0]?.id
                          ?.toString()
                          ?.replace(/(\d{3})(\d{3})(\d{4})/, "$1-$2-$3")
                      : ""}
                  </React.Fragment>
                }
                placement="bottom"
                arrow
              >
                <IconButton className="infoIconContainer" size="small">
                  <InfoOutlinedIcon className="infoIcon" fontSize="small" />
                </IconButton>
              </GCTooltip>
              <ListItemText
                className="headerListItemName"
                disableTypography={true}
                primary={
                  account?.name
                    ? account?.name
                    : localStorageData?.userType === "SuperAdmin"
                    ? account?.parent
                    : "Choose Account"
                }
                // secondary={
                //   account?.id
                //     ? account?.id
                //         ?.toString()
                //         ?.replace(/(\d{3})(\d{3})(\d{4})/, "$1-$2-$3")
                //     : localStorageData?.userType === "SuperAdmin"
                //     ? account?.accounts?.[account?.parent]?.id
                //         ?.toString()
                //         ?.replace(/(\d{3})(\d{3})(\d{4})/, "$1-$2-$3")
                //     : ""
                // }
              />
            </Button>
          )} */}
                    <HeaderUserBox />
                    {account?.open && (
                        <AccountChangeModal
                            open={account?.open ? true : false}
                            onClose={() =>
                                setAccount((prevData: any) => {
                                    return { ...prevData, open: null };
                                })
                            }
                        // data={customerData?.items}
                        // loading={loading}
                        />
                    )}
                </Grid>
            </Grid>
        </Box>
    );
}

export default Header;
